import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ConventionPaymentVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveConventionTransferList = createAsyncThunk<ConventionPaymentVM[], void, { extra: Partial<Dependencies> }>(
  "transfers/retrieveConventionTransferList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listConventionTransfers();
  },
);
